import styled from "styled-components/macro";

export const StyledMaybe = styled.div`
  width: 458px;
  height: 100px;
  /* border: 1px solid #e6e6e6; */
  border-radius: 10px;
  /* background: var(--container-color-2); */
`;

export const StyledMaybeLeft = styled.div`
  width: 76px;
  border-right: 1.5px solid var(--divider);
  float: left;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }
  svg {
    margin-top: 30px;
    transition: all 300ms;
  }
`;

export const StyledMaybeRight = styled.div`
  width: 76px;
  border-left: 1.5px solid var(--divider);
  float: right;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(158, 158, 158, 0.2);
  }
  &:active {
    background: rgba(158, 158, 158, 0.4);
  }

  svg {
    margin-top: 25px;
    transition: all 300ms;
  }
`;

export const StyledMaybeMiddle = styled.div`
  width: 280px;
  padding-left: 10px;
  padding-right: 10px;
  color: var(--grey-0);
  font-family: "Inter";
  text-align: ${({ length }) => (length > 120 ? "left" : "center")};

  ${({ length }) => length <= 9 && "font-size: 55px;"};
  ${({ length }) => length > 9 && length <= 11 && "font-size:50px;"};
  ${({ length }) => length > 11 && length <= 18 && "font-size: 32px;"};
  ${({ length }) => length > 18 && length <= 35 && "font-size: 28px;"};
  ${({ length }) => length > 35 && length <= 50 && "font-size: 24px;"};
  ${({ length }) => length > 50 && length <= 65 && "font-size: 20px;"};
  ${({ length }) => length > 65 && length <= 100 && "font-size: 18px;"};
  ${({ length }) => length > 90 && "text-align: justify;"};
  ${({ length }) => length > 100 && length <= 150 && "font-size: 16px;"};
  ${({ length }) => length > 150 && length <= 180 && "font-size: 14px;"};
  ${({ length }) => length > 180 && "font-size: 13px;"};

  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;

  span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }
`;

export const StyledMaybeContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 458px;
  height: 0px;
  opacity: 0;
  margin-top: 0px;
  transition: all 200ms;
  ${({ born }) => (born ? "height: 100px; margin-top: 22px; opacity:1;" : "")}
  box-shadow: var(--chip-drop-shadow);
  background: var(--menu-color-fullscreen);
  border-radius: 10px;

  &.invisible {
    transition: all 0s;
    opacity: 0;
  }

  &.small {
    transition: all 200ms;
    height: 0;
    margin: 0;
    padding: 0;
  }

  &:nth-child(odd) {
    transform: ${({ rotation, items }) => rotation && `rotate(${items % 2 !== 0 ? "-" : ""}${rotation}deg)`};
  }
  &:nth-child(even) {
    transform: ${({ rotation, items }) => rotation && `rotate(${items % 2 !== 0 ? "" : "-"}${rotation}deg)`};
  }
  &:hover {
    transform: rotate(0deg) scale(1.05);
  }

  &:nth-child(n + 6):last-child {
    margin-bottom: 50px;
  }
`;
